export default __webpack_public_path__ + "images/35345d26ff72075ff4529a2366e43459.jpg";